var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-overlay",
    {
      staticClass: "d-inline-block",
      attrs: {
        show: _vm.busy,
        rounded: "",
        opacity: "0.6",
        "spinner-small": "",
        "spinner-variant": "secondary"
      }
    },
    [
      _c(
        "b-button",
        {
          staticStyle: { padding: "1px 12px" },
          attrs: { variant: "secondary" },
          on: {
            click: function($event) {
              return _vm.sendInvoice()
            }
          }
        },
        [_vm._v("\n    E-mail\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }